/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper", {});

// swiper change event
productImages.on('slideChange', function () {
    // update thumbnail
    document.querySelector(".productThumbnail.active").classList.remove("active");
    document.querySelectorAll(".productThumbnail")[productImages.activeIndex].classList.add("active");
});

// thumbnail
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // change active slide
        productImages.slideTo(parseInt(this.getAttribute("index")) - 1);
        // update active class
        document.querySelector(".productThumbnail.active").classList.remove("active");
        this.classList.add("active");
    });
});

/**************
 Product Options
 ***************/

// update active variant on click
document.querySelectorAll(".productOptionValue").forEach(function (element) {
    element.addEventListener("click", function () {
        // update active option
        this.parentElement.querySelector(".productOptionValue.active").classList.remove("active");
        this.classList.add("active");

        // update product
        updateProduct();
    });
})

// update active variant
function updateProduct() {
    // find active options
    let selectedOptions = [];
    document.querySelectorAll(".productOption .productOptionValue.active").forEach(function (element) {
        selectedOptions.push(element.getAttribute("value"));
    });

    // find the correct variant based on the active options
    for (let i = 0; i < product.variants.length; i++) {
        if (JSON.stringify(product.variants[i].options) == JSON.stringify(selectedOptions)) {
            activeVariant = product.variants[i];
            break;
        }
    }

    // update price
    document.querySelector("#productPrice").textContent = price(activeVariant.price);

    // check if the variant is in stock
    if (activeVariant.available == true) {
        document.querySelector("#productATC").classList.remove("disabled");
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productATC").classList.add("disabled");
        document.querySelector("#productATC").textContent = "Sold Out";
    }

    // change active slide to variant image
    if (activeVariant.featured_image != null) {
        document.querySelector(`#thumbnail-${activeVariant.featured_image.id}`).click();
    }

    // update active variant
    //history.replaceState(undefined, undefined, `?variant=${activeVariant.id}`);
}

/*************
 * Product Personalize
 */

const personalizeEl = document.querySelector("#productPersonalize");
if (personalizeEl) {
    personalizeEl.addEventListener("keyup", function (e) {
        let maxLength = parseInt(this.getAttribute("length"));
        if (this.value.length > maxLength) {
            this.value = this.value.substring(0, maxLength)
        }
    });
}


/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productATC").classList.add("loading");

    let formData = {
        quantity: 1,
        id: activeVariant.id,
    };

    if (personalizeEl && personalizeEl.value.length > 0) {
        formData.properties = {
            Personalize: personalizeEl.value
        };
    }

    // Collect PPLR app properties
    const pplrProperties = {};
    document.querySelectorAll('.pplr-wrapper input[name], .pplrform input[name]').forEach(function (input) {
        if (input.value) {
            const match = input.name.match(/properties\[(.+)\]/);
            if (match) {
                pplrProperties[match[1]] = input.value;
            } else {
                pplrProperties[input.name] = input.value;
            }
        }
    });

    if (Object.keys(pplrProperties).length > 0) {
        formData.properties = Object.assign({}, formData.properties || {}, pplrProperties);
    }

    // add product
    await addProduct(formData);

    // open cart
    openCart();

    // remove loading animation
    setTimeout(function () {
        document.querySelector("#productATC").classList.remove("loading");
    }, 500);
});


/**************
 Product Tabs
 ***************/

document.querySelectorAll(".productTab").forEach(function (element) {
    element.addEventListener("click", function () {
        //is this current one open, if so close
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            this.nextElementSibling.removeAttribute("style");
        } else {
            //check if already open
            if (document.querySelector(".productTab.active")) {
                document.querySelector(".productTab.active").nextElementSibling.removeAttribute("style");
                document.querySelector(".productTab.active").classList.remove("active");
            }
            this.classList.add("active");
            this.nextElementSibling.style.height = `${this.nextElementSibling.scrollHeight}px `;
        }
    });
});


/**********
 Sizing Popup
 *********/


// open cart sizing message
function openSizing() {
    document.querySelector("#sizing").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close cart sizing message
function closeSizing() {
    document.querySelector("#sizing").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
}

// event listener to open
if (document.querySelector("#productSizing")) {
    document.querySelector("#productSizing").addEventListener("click", openSizing);
}

// event listen to close
document.querySelector("#sizingExit").addEventListener("click", closeSizing);
document.querySelector("#sizing").addEventListener("click", function (e) {
    if (e.target == this) {
        closeSizing();
    }
});